import { gql } from '@apollo/client';

export const STOCK_ALLOCATION_PLAN_FIELDS = gql`
  fragment StockAllocationPlanFields on StockAllocationPlan {
    id portfolioId name currency createdAt updatedAt totalAmount remainingAmount
    breakdowns {
      sectors { id name amount completedAmount totalAmount percentage currentPercentage afterPercentage }
      instrumentTypes { id name amount completedAmount totalAmount percentage currentPercentage afterPercentage }
      locations { id name amount completedAmount totalAmount percentage currentPercentage afterPercentage }
    }
    items {
      id
      stock { id symbol name exchange currency instrumentType sector }
      amount percentage currentPositionValue completed completedTransactionId
      targetLocation { id name }
      nativePrice priceInPlanCurrency estimatedQuantity quoteTimestamp warning
    }
  }
`;

export const GET_STOCK_ALLOCATION_PLANS = gql`
  query GetStockAllocationPlans($portfolioId: ID!) {
    stockAllocationPlans(portfolioId: $portfolioId) { ...StockAllocationPlanFields }
  }
  ${STOCK_ALLOCATION_PLAN_FIELDS}
`;

export const GET_STOCK_ALLOCATION_PLAN = gql`
  query GetStockAllocationPlan($portfolioId: ID!, $planId: ID!) {
    stockAllocationPlan(portfolioId: $portfolioId, planId: $planId) { ...StockAllocationPlanFields }
  }
  ${STOCK_ALLOCATION_PLAN_FIELDS}
`;
